<template>
  <div class="integral-record">
    <div class="main">
      <h2>积分记录</h2>
      <ul v-if="list && list.length > 0">
        <li v-for="(item, index) in list" :key="index">
          <p>
            {{ item.title }}
            <em>{{ item.integral }}</em>
          </p>
          <span>{{ item.createTime }}</span>
        </li>
      </ul>
      <p v-else class="none">暂无数据~</p>
    </div>
  </div>
</template>
<script>
import { integralRecord } from '@/api/activity'
export default {
  name: 'IntegralRecord',
  data() {
    return {
      params: {
        pn: 1,
        ps: 20,
        flag: 1,
      },
      list: [],
      userCode: '',
      isLoading: true,
    }
  },
  mounted() {
    document.title = '积分记录'
    this.userCode = this.$route.query.userCode
    this.init()
    this.scro11()
  },
  methods: {
    async init() {
      let res = await integralRecord(this.params)
      if (res.code == '1000' && res.data.length > 0) {
        this.list.push(...res.data)
        this.isLoading = true
        this.list.forEach((item) => {
          item.title = item.detailExplain.split(' ')[0]
          item.integral = item.detailExplain.split(' ')[1]
        })
      } else if (res.data.length <= 0) {
        this.isLoading = false //无数据可以加载
      }
    },
    //滚动分页加载数据
    scro11() {
      document.getElementsByClassName('main')[0].onscroll = async () => {
        //距离底部时加载一次
        let bottomofwindow =
          document.getElementsByClassName('main')[0].scrollTop +
            (window.innerHeight -
              document.getElementsByClassName('title')[0].offsetHeight) >=
          document.getElementsByClassName('main')[0].scrollHeight
        if (bottomofwindow && this.isLoading == true) {
          this.params.pn = this.params.pn + 1 //每次分页+1
          this.init()
        }
      }
    }
  },
}
</script>
<style lang="less" scoped>
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: transparent !important; /* 设置滚动条追踪区的背景色为透明 */
}
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.integral-record {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f2f5fa;
  .main {
    width: 100%;
    flex: 1;
    height: auto;
    overflow-y: scroll;
    padding-top: 3.15vh;
    h2 {
      font-size: 4vw;
      text-align: center;
    }
    .none {
      margin: 30vh auto;
      font-size: 4vw;
      text-align: center;
    }
  }
  ul {
    width: 90.87vw;
    height: auto;
    background: #ffffff;
    border-radius: 1.82vw;
    margin: 2vw auto 6.9vh;
    padding-bottom: 2vh;
    li {
      width: 78.65vw;
      height: 9.75vh;
      padding-top: 2.25vh;
      border-bottom: 0.15vh solid #ededed;
      margin-left: 10.27vw;
      p {
        color: #333333;
        font-size: 3.8vw;
        em {
          color: #fb4933;
          margin-left: 3vw;
        }
        &::before {
          content: '';
          display: inline-block;
          vertical-align: middle;
          width: 2.08vw;
          height: 2.08vw;
          background: #22c089;
          border-radius: 100%;
          margin-left: -5vw;
          margin-right: 2vw;
        }
      }
      span {
        display: block;
        margin-top: 1.5vh;
        color: #999999;
        font-size: 3.12vw;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/integralRecord.vue